export default {
  'activityLog.name': 'Activity Log',
  'activityLog.table.userName': 'Username',
  'activityLog.table.typeAccount': 'Account Type',
  'activityLog.table.group': 'User Group',
  'activityLog.table.system': 'System Impact',
  'activityLog.table.impactTime': 'Impact Time',
  'activityLog.table.performedAction': 'Performed Action',
};
